import * as React from 'react';
import { RadioButtonGroup as UIKitRadioButtonGroup } from '@cian/ui-kit';
import { useValueController } from './hooks';
import { IOption, TOptionValue } from './types';

export interface IRadioButtonGroupProps {
  options: IOption[];
  value?: TOptionValue;
  onChange(value?: TOptionValue): void;
  anyOption?: boolean;
  spliced?: boolean;
}

export const RadioButtonGroup: React.VFC<IRadioButtonGroupProps> = ({ spliced, ...props }) => {
  const { options, value, onChange } = useValueController(props);

  return <UIKitRadioButtonGroup spliced={spliced} options={options} value={value} onChange={onChange} />;
};
